import ReactDOM from "react-dom";
import PortalBody from "../components/layouts/PortalBody";
import { BrowserRouter } from "react-router-dom";

const Login = () => {
  const loginManager = () => {
    const formLogin = document.getElementById("formLogin");
    formLogin.addEventListener("submit", (e) => {
      const formData = new FormData(formLogin);
      fetchContact(formData)
        .then((data) => {
          if (data.length !== 0) {
            saveClientContactInStorage(data);
            ReactDOM.render(
              <BrowserRouter>
                <PortalBody />
              </BrowserRouter>,
              document.getElementById("root")
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
      e.preventDefault();
    });
  };

  const fetchContact = async (formDt) => {
    const url = "https://www.innovations.co.ke/portalapi/public/api/managerLogin";
    const options = {
      method: "POST",
      body: formDt,
    };
    const response = await fetch(url, options);
    if (response.status !== 200) {
      throw new Error("There was an error fetching Manager :" + response.status);
    }
    const data = await response.json();
    return data;
  };

  const saveClientContactInStorage = (data) => {
    data.map((dt) => {
      if (typeof Storage !== "undefined") {
        localStorage.setItem("manager_email", dt.email);
        localStorage.setItem("manager_name", dt.name);
        localStorage.setItem("manager_id", dt.manager_id);
      } else {
        console.log("Could not save manager data in local storage");
      }
    });
  };

  return (
    <div className="card col-md-4 mx-auto" style={{ marginTop: "20%" }}>
      <div className="card-header text-center bg-white">
        <h1>
          <span className="text-danger fw-bolder">Login </span>
        </h1>
      </div>
      <div className="card-body">
        <form id="formLogin" className="d-grid gap-3">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              className="form-control"
              autoComplete="off"
              id="email"
              name="email"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              autoComplete="off"
              id="password"
              name="password"
              required
            />
          </div>
          <button
            type="submit"
            id="submit"
            onClick={loginManager}
            className="btn btn-secondary mx-auto fs-5"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
